<form #theForm="ngForm" (ngSubmit)="import()" [formGroup]="formData" novalidate>

  <div class="btn-toolbar">
    <div class="btn-group">
      <button type="button" class="btn btn-primary" (click)="cancel()">Cancel</button>
    </div>
    <div class="btn-group">
      <button type="submit" *bizPermissionRequired="'Developer_Action_Import'" class="btn btn-primary"
      [disabled]="!canImport()">Import</button>
    </div>
  </div>

  <hr />

  @if (compareStatus.Result.ItemGroupResults.length < 1) {
    <p>No valid data to import in uploaded file</p>
  }

  @if (versionMismatchDetected) {
    <div class="panel panel-warning">
      <div class="panel-heading">
        <h3 class="panel-title">Version mismatch</h3>
      </div>
      <div class="panel-body">
        <span>
          Source system version {{compareStatus.Result.MetaData.ExportLinkVersion}} doesn't match target system version {{compareStatus.Result.MetaData.ImportLinkVersion}}.
        </span>
      </div>
    </div>
  }

  @for (group of compareStatus.Result.ItemGroupResults; track group) {
    <h2 class="space-above">
      <div class="tooltip-field">{{ getGroupName(group) }}<span class="tooltip-text">{{ group.ObjectType }}</span></div>
    </h2>
    @for (item of group.ItemResults; track item) {
      <div class="panel panel-info" style="cursor: pointer;">
        <div class="panel-heading" (click)="item.show = !item.show" >
          @if (item.StatusMessage?.length > 0) {
            <div class="panel panel-danger" style="cursor: pointer;">
              <span>{{ item.StatusMessage }}</span>
            </div>
          }
          <h3 class="panel-title">
            <span>{{ getItemName(item) }}</span>
            <small class="label" [class.label-default]="item.Status === 'Ignored'" [class.label-success]="item.Status === 'Unchanged'"
              [class.label-warning]="item.Status === 'New'" [class.label-danger]="item.Status === 'Changed' || item.Status === 'MissingPermission' || item.Status === 'MissingReference' || item.Status === 'BlockImport' || item.Status === 'Deleted'" >{{
            item.Status }}</small>
          </h3>
        </div>
        @if ((item.Status === 'Changed' || item.Status === 'New' || item.Status === 'MissingReference' || item.Status === 'Deleted') && item.show) {
          <table class="table table-striped table-bordered">
            <tr>
              <th>Property</th>
              <th>Previous value</th>
              <th>New value</th>
            </tr>
            @for (change of item.Properties; track change) {
              <tr>
                @if (change.PreviousValue !== change.CurrentValue) {
                  <td>{{ change.PropertyName }}</td>
                }
                @if (change.PreviousValue === null && change.PreviousValue !== change.CurrentValue) {
                  <td><strong>(null)</strong></td>
                }
                @if (change.PreviousValue === '' && change.PreviousValue !== change.CurrentValue) {
                  <td><strong>(blank)</strong></td>
                }
                @if (change.PreviousValue !== null && change.PreviousValue !== '' && change.PreviousValue !== change.CurrentValue) {
                  <td class="allow-newline">{{ formatText(change.PreviousValue, change.PreviousValueDisplay) }}</td>
                }
                @if (change.CurrentValue === null && change.PreviousValue !== change.CurrentValue) {
                  <td><strong>(null)</strong></td>
                }
                @if (change.CurrentValue === '' && change.PreviousValue !== change.CurrentValue) {
                  <td><strong>(blank)</strong></td>
                }
                @if (change.CurrentValue !== null && change.CurrentValue !== '' && change.PreviousValue !== change.CurrentValue) {
                  <td class="allow-newline">{{ formatText(change.CurrentValue, change.CurrentValueDisplay) }}</td>
                }
              </tr>
            }
          </table>
        }
      </div>
    }
  }

  <hr />

  <div class="btn-toolbar">
    <div class="btn-group">
      <button type="button" class="btn btn-primary" (click)="cancel()">Cancel</button>
    </div>
    <div class="btn-group">
      <button type="submit" *bizPermissionRequired="'Developer_Action_Import'" class="btn btn-primary"
      [disabled]="!canImport()">Import</button>
    </div>
  </div>

  <div>&nbsp;</div>
</form>
